<template>
	 <el-form :model="formData" label-width="100px">
        <el-row>
			<!-- {{ formData.way }} -->
			<el-col :span="7" class="col-h">
                <el-form-item label="付费方式" prop="way" required >
                    <el-select v-model="formData.way" @change="handleChange"> 
                        <el-option 
                            v-for="item in global.priceTypeList" 
                            :label="item.label" 
                            :value="item.value"
                            :key="item.value"
                        />
                    </el-select>
                </el-form-item>
            </el-col>
			<el-col :span="7" class="col-h">
				<el-form-item label="出价" prop="price" :rules="moneyRules">
					<el-input 
						v-model="formData.price" placeholder="请输入价格"
						@input="(value)=>handleInput('price', value)"
					/>
				</el-form-item>
				<div class="form-item__tip" v-if="priceAvg">
					<TipInfo :data="priceAvg"/>
				</div>
			</el-col>
			<el-col :span="7" class="col-h" v-if="formData.way">
				<el-form-item label="效果增强" prop="powerful" >
					<el-switch v-model="formData.powerful" @change="(value)=>handleSwitchChange(value, 'powerful')" />
				</el-form-item>
			</el-col>
            <slot v-if="formData.way"/>
			
			<slot name="bottom"/>
			<el-col v-if="formData.way &&formData.powerful" :span="24">
				<el-row class="row-box">
					<p class="border-title">增强效果</p>
					<el-col :span="7" class="col-h" >
						<!-- {{ global.config.enhanced_conv_type }} -->
						<el-form-item label="增强转化目标"  required>
							<el-select 
								v-model="formData.powerfulName" 
							>
								<el-option 
									v-for="item in ( global.config.enhanced_conv_type || [] )" 
									:label="item.label" :key="item.value" 
									:value="item.value"
								/>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="17" class="col-h">
						<el-form-item label="增强调价系数" prop="coef" :rules="coefRules" >
							<el-input 
								v-model="formData.coef_low" 
								style="width: 120px;"
								placeholder="调价系数下限"
							/>
							~
							<el-input 
								v-model="formData.coef_tall" 
								style="width: 120px;"
								placeholder="调价系数上限"
							/>
						</el-form-item>
					</el-col>
				</el-row>
			</el-col>
        </el-row>
    </el-form>
	<!-- commonForm -->
</template>

<script>
import { validNum } from '@/utils/validate'
import { numStrip } from '@/utils'
import TipInfo from './tipInfo'
export default {
	name:'NonConversionForm',
	components: {  TipInfo  },
	inject: [ 'global' , 'moneyRules'],
	props: ["formData"],
	data() { 

		const validCoef = (rule, value, callback) => {
			const coef_low = this.formData.coef_low;
			const coef_tall = this.formData.coef_tall;
			if(!validNum(coef_low) || !validNum(coef_tall)) {
				callback(new Error('请输入正确的系数'));
			}else {
				if(coef_low && coef_tall) {
					if(+coef_low > +coef_tall) {
						return callback(new Error('系数上限不能小于系数下限'));
					}
				}
				if(!(+coef_low >= 0.2 && +coef_low <= 1)) {
					return callback(new Error('系数下限范围0.2-1'));
				}
				if(!(+coef_tall >= 1 && +coef_tall <= 5)) {
					return callback(new Error('系数上限范围1-5'));
				}
				callback();
			}
		}

		return {
			priceAvg: '', // 出价均值,
			coefRules: [
				{ validator: validCoef, trigger: [ 'blur'] }
			]
		}
	},
    methods: {
		handleChange() {
			const data = _.omit(this.global.defaultFormData, [ 'way', 'price']);
			Object.keys(data).forEach(key => {
				this.$set(this.formData, key, data[key]);
			})
		},
		handleSwitchChange(value, key) {
			// powerful deep 互斥
			if(value) {
				this.$set(this.formData, 'deep', false);
				this.$set(this.formData, 'deepTarget', '');
				this.$set(this.formData, 'deepCost', '');
			}else {
				this.$set(this.formData, 'powerfulName', '');
				this.$set(this.formData, 'coef_low', '');
				this.$set(this.formData, 'coef_tall', '');
			}
		},
		handleInput(key, value) {
			if(!validNum(value)) {
				this.priceAvg = ''
				return 
			}
			const num = this.global.handleValidNumber(value);
			if (num) {
				this.formData[key] = num;
			}
			this.avgValue(this.formData[key]);
		},
		async avgValue(value) {
			if(!value) {
				this.priceAvg = '';
				return
			}
			const params = {
				pay_type: this.formData.way,
			}
			const result = await this.global.getBatchConversionPrice(params);
			if(!result.price_avg) {
				this.priceAvg = '';
				return
			}
			const n = numStrip(value - result.price_avg);
			if (n>0) {
				this.priceAvg = `高${n}`;
			}else if(n === 0) {
				this.priceAvg = `${n}`;
			}else {
				this.priceAvg = `低${-n}`;
			}
		}
    },
	watch: {
		'formData.way': {
			handler (n) {
				this.avgValue(this.formData.price);
			},
		}
	}
}
</script>
<style>
.col-h {
	min-height: 52px;
}
</style>
<style lang="scss" scoped>
.row-box {
	border: 1px solid #dcdfe6;
	margin: 0 12px 20px;
	border-radius: 8px;
	padding-top: 20px;
	position: relative;
}
.border-title {
	position: absolute;
	top: -8px;
	left: 20px;
	color: #606266;
	background: #fff;
}
.form-item__tip {
	margin-top: -16px;
	margin-left: 100px;
	color: #666;
	font-size: 12px;
}
</style>